<template>
  <div>
    <HTTPresponse :alert="httpalert" @changeHTTPBoxState="HTTPState"></HTTPresponse>
    <v-layout
      row
      ma-0
      justify-space-between
    >
      <v-btn
        v-if="changeFirm"
        class="mr-6 mb-3"
        fab
        elevation="0"
        max-width="100"
        max-height="100"
        width="100"
        height="100"
        @click.stop="dialogFirm = true"
      >
        <v-img
          class="rounded"
          :src="img"
          aspect-ratio="1"
          max-width="100"
          max-height="100"
          width="100"
          height="100"
        ></v-img>
      </v-btn>
      <!-- else just show image -->
      <v-img
        v-else
        class="rounded mr-6 mb-3"
        :src="img"
        aspect-ratio="1"
        max-width="100"
        max-height="100"
        width="100"
        height="100"
      ></v-img>

      <v-layout
        justify-center
        column
      >

        <h2 class="mb-3" v-html="selectedFirm && selectedFirm.title ? selectedFirm.title : title ? title : ''"></h2>
        <small class="mb-2" v-html="selectedFirm && selectedFirm.address ? selectedFirm.address : address ? address : ''"></small>
        <!--  -->
        <small class="mb-3" v-html="selectedFirm && selectedFirm.zip && selectedFirm.city ? `${selectedFirm.zip} ${selectedFirm.city}` :
                                    zip && city ? `${zip} ${city}` : ''"></small>
        
        <!-- <small id="ICI" v-html="unescaped(zip)"></small>
        <small id="LABA">{{zip}}</small> -->
        <!--  -->
        <small class="mr-3" v-html="selectedFirm && selectedFirm.vat ? selectedFirm.vat : vat ? vat : ''"></small>
        <small class="mr-3" v-html="selectedFirm ? selectedFirm.nr : nr"></small>
        <v-layout
          justify-space-between
          align-center
          row
          ma-0
        >
          <small class="mr-3" v-html="selectedFirm ? selectedFirm.reg : reg"></small>
          <button v-if="!noEdit && (selectedFirm || (title && id))" class="link" @click="dialogEdit = true">
            {{ $t('firm-card.btn') }}
            <v-icon color="primary" class="ml-1" size="12">icon-edit</v-icon>
          </button>
          <button v-else-if="changeFirm" class="link" @click.stop="dialogFirm = true">
            {{ $t('firm-card.btn-select') }}
            <v-icon color="primary" class="ml-1" size="12">icon-edit</v-icon>
          </button>
        </v-layout>
      </v-layout>
    </v-layout>

   <!-- Dialog : edit firm -->
   <v-dialog
      v-model="dialogEdit"
      max-width="650"
   >
      <v-card class="ma-0">
        <v-card-title class="headline mb-5">{{ $t("firm-card.dialog-1.title") }}</v-card-title>

        <v-card-text>
          <v-text-field
            v-model="editTitle"
            :label="$t('firm-card.dialog-1.label-1')"
            outlined
            :rules="[rules.notEmpty]"
          ></v-text-field>
          <v-text-field
            v-model="editAddress"
            :label="$t('firm-card.dialog-1.label-2')"
            outlined
            :rules="[rules.notEmpty]"
          ></v-text-field>
          <v-text-field
            v-model="editCity"
            :label="$t('firm-card.dialog-1.label-3')"
            outlined
            :rules="[rules.notEmpty]"
          ></v-text-field>
          <v-text-field
            v-model="editZip"
            :label="$t('firm-card.dialog-1.label-4')"
            outlined
            :rules="[rules.number]"
          ></v-text-field>
          <v-text-field
            v-model="editVat"
            :label="$t('firm-card.dialog-1.label-5')"
            outlined
            :rules="[rules.notEmpty]"
          ></v-text-field>
          <v-text-field
            v-model="editNr"
            :label="$t('firm-card.dialog-1.label-6')"
            outlined
            :rules="[rules.notEmpty]"
          ></v-text-field>
          <v-text-field
            v-model="editReg"
            :label="$t('firm-card.dialog-1.label-7')"
            outlined
            :rules="[rules.notEmpty]"
          ></v-text-field>
          <!-- <v-text-field
            v-model="editRegistrationNum"
            :label="'testage'"
            outlined
            :rules="[rules.notEmpty]"
          ></v-text-field> -->
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            rounded
            text
            color="error"
            @click="dialogEdit = false"
          >
            {{ $t('firm-card.dialog-1.btn-1') }}
          </v-btn>
          <v-btn
            outlined
            rounded
            color="primary"
            @click="editFirm"
            :disabled="editTitle && editAddress && editCity && editZip && editVat && editNr && editReg ?
                       false : true"
          >
            {{ $t('firm-card.dialog-1.btn-2') }}
          </v-btn>
        </v-card-actions>
      </v-card>
   </v-dialog><!-- Dialog : edit firm -->

   <!-- Dialog : select firm -->
   <v-dialog
      v-if="changeFirm"
      v-model="dialogFirm"
      max-width="500"
    >
      <v-card class="ma-0">
        <v-card-title class="headline">{{ $t('firm-card.dialog-2.title') }}</v-card-title>

        <v-card-text v-if="firms">
          <v-radio-group
            v-model="selectedFirm"
            column
          >
            <v-radio
              v-for="firm in firms"
              :key="firm.id"
              :label="unescaped(firm.title)"
              :value="firm"
              @change="emitToParent(firm)"
            ></v-radio>
          </v-radio-group>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            outlined
            rounded
            color="primary"
            @click="emitToParent; dialogFirm = false"
          >
            {{ $t('firm-card.dialog-2.btn-1') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { createFirm } from '@/js/firm/createFirm'
import { getFirm } from '@/js/firm/getFirm'
import HTTPresponse from '@/components/app/HTTPresponse'

export default {
  props: {
    id: String,
    title: {
      type: String,
      default: () => 'No name'
    },
    img: {
      type: String,
      default: () => `${require('@/assets/images/entreprise.svg')}`
    },
    address: String,
    city: String,
    zip: String,
    vat: String,
    nr: String,
    reg: String,
    // registrationNum: String,
    reload: Boolean,
    changeFirm: Boolean,
    noEdit: {
      type: Boolean,
      default: () => false
    }
  },
  components: {
    HTTPresponse: HTTPresponse
  },

  data () {
    return {
      dialogFirm: false,
      selectedFirm: null,
      dialogEdit: false,

      editAddress: this.address ? this.address : '',
      editCity: this.city ? this.city : '',
      editTitle: this.title ? this.title : '',
      editZip: this.zip ? this.zip : '',
      editVat: this.vat ? this.vat : '',
      editNr: this.nr ? this.nr : '',
      editReg: this.reg ? this.reg : '',
      // editRegistrationNum: this.registrationNum ? this.registrationNum : '',

      firms: null,

      rules: {
        notEmpty: value => {
          if (value === '') return true
          const reg = /^\s+$/
          if (reg.test(value) === true) return this.$t('rules-field.empty')
          else return true
        },
        number: value => {
          if (value === '') return true
          const reg = /^[0-9]+$/ // should contain number
          return reg.test(value) || this.$t('rules-field.number')
        }
      },

      httpalert: false
    }
  },

  created () {
    // if (!this.$store.getters['auth/isAuthenticated']) return

    const valid = this.$route.params.validkey ? this.$route.params.validkey : this.$store.state.auth.token
    getFirm(valid)
      .then(response => {
        this.firms = response
      })
      .catch(() => {
        this.httpalert = true
        setTimeout(() => {
          this.httpalert = false
        }, 4000)
      })
  },

  methods: {
    emitToParent (firm) {
      this.$emit('selectFirmToParent', firm)
    },

    editFirm () {
      // if (!this.$store.getters['auth/isAuthenticated']) return
      // console.log('token : ' + this.$store.state.auth.token)
      if (!this.id) return

      const params = {
        address: this.editAddress,
        city: this.editCity,
        title: this.editTitle,
        zip: this.editZip,
        vat: this.editVat,
        nr: this.editNr,
        reg: this.editReg,
        id: this.id,
        key: this.$store.state.auth.token
      }
      createFirm(params)
        .then(() => {
          // if (this.reload) this.$emit('editFirmToParent')
          this.$emit('editFirmToParent')
          this.dialogEdit = false
        })
        .catch(() => {
          this.dialogEdit = false
          this.httpalert = true
          setTimeout(() => {
            this.httpalert = false
          }, 4000)
        })
    },

    unescaped (string) {
      var txt = document.createElement('textarea')
      txt.innerHTML = string
      return txt.value
    },

    HTTPState (value) {
      this.httpalert = this.value
    }
  }
}
</script>
